import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_BEGIN,
  MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_SUCCESS,
  MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_FAILURE,
  MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function removeAllocatedItem(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/removeAllocatedItem`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissRemoveAllocatedItemError() {
  return {
    type: MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_DISMISS_ERROR,
  };
}

export function useRemoveAllocatedItem() {
  const dispatch = useDispatch();

  const { removeAllocatedItemPending, removeAllocatedItemError } = useSelector(
    state => ({
      removeAllocatedItemPending: state.manageSubs.removeAllocatedItemPending,
      removeAllocatedItemError: state.manageSubs.removeAllocatedItemError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(removeAllocatedItem(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissRemoveAllocatedItemError());
  }, [dispatch]);

  return {
    removeAllocatedItem: boundAction,
    removeAllocatedItemPending,
    removeAllocatedItemError,
    dismissRemoveAllocatedItemError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        removeAllocatedItemPending: true,
        removeAllocatedItemError: null,
      };

    case MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_SUCCESS:
      // The request is success
      return {
        ...state,
        removeAllocatedItemPending: false,
        removeAllocatedItemError: null,
      };

    case MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_FAILURE:
      // The request is failed
      return {
        ...state,
        removeAllocatedItemPending: false,
        removeAllocatedItemError: action.data.error,
      };

    case MANAGE_SUBS_REMOVE_ALLOCATED_ITEM_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        removeAllocatedItemError: null,
      };

    default:
      return state;
  }
}
